import axios from 'axios'
import { IKeycloakTokenResponse } from '../../shared/interfaces';

export class KeycloakService {
    // No KeycloakService
    public static async getToken() {
        console.log('Ambiente:', process.env.NODE_ENV);
        console.log('URL base:', window.location.origin);
        console.log('Caminho:', window.location.pathname);

        // Usar o endpoint do proxy
        const response = await axios.post<IKeycloakTokenResponse>('/xuwweb/api/auth/token');

        console.log('Token obtido com sucesso');
        return response.data;
    }
}